export const ItemGroupsData = [
    { id: 1, name: "Electronics" },
    { id: 2, name: "Hardware" },
];